module.exports = __webpack_public_path__ + "img/AccessAlarm.b6ce18f1.svg";